export const keys = {
  account: (accountId: string) => ['account', accountId],
}
